import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@wausauCustomBlueprint/Store/CustomApplicationState";
import { getWausauRequestRMAReturnPO } from "@wausauCustomBlueprint/Store/CustomSelector";
import wausauRequestRMASetReturnPO from "@wausauCustomBlueprint/Store/Data/RequestRMA/WausauRequestRMASetReturnPO";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    returnPO: getWausauRequestRMAReturnPO(state),
});

const mapDispatchToProps = {
    wausauRequestRMASetReturnPO,
};

export interface RequestRmaReturnPOStyles {
    wrapper?: InjectableCss;
    returnPOText?: TextFieldPresentationProps;
}

export const returnPOStyles: RequestRmaReturnPOStyles = {
    wrapper: {
        css: css`
            padding-bottom: 20px;
        `,
    },
};

const styles = returnPOStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RequestRmaReturnPO: FC<Props> = ({ returnPO, wausauRequestRMASetReturnPO }) => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        wausauRequestRMASetReturnPO({ returnPO: event.currentTarget.value });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <TextField
                label={translate("Return PO")}
                value={returnPO}
                onChange={changeHandler}
                {...styles.returnPOText}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestRmaReturnPO),
    definition: {
        allowedContexts: ["RequestRmaPage"],
        group: "Return Request (RMA)",
        displayName: "Return PO",
        fieldDefinitions: [],
    },
};

export default widgetModule;
